__turbopack_context__.v({
  "toggleSwitch": "An2urq_toggleSwitch",
  "toggleSwitchHelper": "An2urq_toggleSwitchHelper",
  "toggleSwitchLabel": "An2urq_toggleSwitchLabel",
});
